var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifyYourIdentity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 448.736,
    height: 334.407,
    viewBox: "0 0 448.736 334.407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2867046",
    "data-name": 2867046,
    transform: "translate(0 -54.95)",
    opacity: 0.605
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    transform: "translate(0 54.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_604",
    "data-name": "Grupo 604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_602",
    "data-name": "Grupo 602"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_226",
    "data-name": "Ret\\xE2ngulo 226",
    width: 448.736,
    height: 0.224,
    transform: "translate(0 293.877)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_780",
    "data-name": "Caminho 780",
    d: "M216.628,308.8H43.335a5.129,5.129,0,0,1-5.125-5.125V60.075a5.129,5.129,0,0,1,5.125-5.125h173.3a5.129,5.129,0,0,1,5.125,5.125v243.6A5.142,5.142,0,0,1,216.628,308.8ZM43.335,55.174a4.907,4.907,0,0,0-4.9,4.9v243.6a4.906,4.906,0,0,0,4.9,4.9h173.3a4.907,4.907,0,0,0,4.9-4.9V60.075a4.907,4.907,0,0,0-4.9-4.9Z",
    transform: "translate(-3.918 -54.95)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_781",
    "data-name": "Caminho 781",
    d: "M432.927,308.8h-173.3a5.129,5.129,0,0,1-5.125-5.125V60.075a5.129,5.129,0,0,1,5.125-5.125h173.3a5.129,5.129,0,0,1,5.125,5.125v243.6A5.129,5.129,0,0,1,432.927,308.8ZM259.625,55.174a4.906,4.906,0,0,0-4.9,4.9v243.6a4.906,4.906,0,0,0,4.9,4.9h173.3a4.907,4.907,0,0,0,4.9-4.9V60.075a4.906,4.906,0,0,0-4.9-4.9Z",
    transform: "translate(-26.093 -54.95)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_603",
    "data-name": "Grupo 603",
    transform: "translate(47.081 299.989)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_227",
    "data-name": "Ret\\xE2ngulo 227",
    width: 28.333,
    height: 0.224,
    transform: "translate(328.358 2.432)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_228",
    "data-name": "Ret\\xE2ngulo 228",
    width: 29.985,
    height: 0.224,
    transform: "translate(223.892)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_229",
    "data-name": "Ret\\xE2ngulo 229",
    width: 56.029,
    height: 0.224,
    transform: "translate(308.847 10.77)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_230",
    "data-name": "Ret\\xE2ngulo 230",
    width: 17.258,
    height: 0.224,
    transform: "translate(0 9.262)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_231",
    "data-name": "Ret\\xE2ngulo 231",
    width: 27.184,
    height: 0.224,
    transform: "translate(25.255 9.262)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_232",
    "data-name": "Ret\\xE2ngulo 232",
    width: 48.966,
    height: 0.224,
    transform: "translate(123.061 5.475)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_618",
    "data-name": "Grupo 618",
    transform: "translate(48.006 36.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_610",
    "data-name": "Grupo 610",
    transform: "translate(249.132 51.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_607",
    "data-name": "Grupo 607",
    transform: "translate(0 50.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_605",
    "data-name": "Grupo 605",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_233",
    "data-name": "Ret\\xE2ngulo 233",
    width: 155.945,
    height: 39.094,
    transform: "translate(39.094) rotate(90)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_234",
    "data-name": "Ret\\xE2ngulo 234",
    width: 34.391,
    height: 34.804,
    transform: "translate(36.946 4.556) rotate(90)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_782",
    "data-name": "Caminho 782",
    d: "M359.69,213.21H344.28a3.566,3.566,0,0,0,3.563,3.563h8.275A3.568,3.568,0,0,0,359.69,213.21Z",
    transform: "translate(-332.436 -209.106)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_235",
    "data-name": "Ret\\xE2ngulo 235",
    width: 34.391,
    height: 34.804,
    transform: "translate(36.948 42.037) rotate(90)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_236",
    "data-name": "Ret\\xE2ngulo 236",
    width: 34.391,
    height: 34.804,
    transform: "translate(36.95 79.517) rotate(90)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_237",
    "data-name": "Ret\\xE2ngulo 237",
    width: 34.391,
    height: 34.804,
    transform: "translate(36.943 116.998) rotate(90)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_783",
    "data-name": "Caminho 783",
    d: "M359.69,254.97H344.28a3.566,3.566,0,0,0,3.563,3.563h8.275A3.568,3.568,0,0,0,359.69,254.97Z",
    transform: "translate(-332.436 -213.387)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_784",
    "data-name": "Caminho 784",
    d: "M359.69,296.73H344.28a3.566,3.566,0,0,0,3.563,3.563h8.275A3.556,3.556,0,0,0,359.69,296.73Z",
    transform: "translate(-332.436 -217.669)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_785",
    "data-name": "Caminho 785",
    d: "M359.69,338.49H344.28a3.566,3.566,0,0,0,3.563,3.563h8.275A3.556,3.556,0,0,0,359.69,338.49Z",
    transform: "translate(-332.436 -221.95)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_238",
    "data-name": "Ret\\xE2ngulo 238",
    width: 155.945,
    height: 19.529,
    transform: "translate(58.62 0.003) rotate(90)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_606",
    "data-name": "Grupo 606",
    transform: "translate(42.622 0.002)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_239",
    "data-name": "Ret\\xE2ngulo 239",
    width: 155.945,
    height: 39.094,
    transform: "translate(39.094 0.006) rotate(90)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_240",
    "data-name": "Ret\\xE2ngulo 240",
    width: 34.391,
    height: 34.804,
    transform: "translate(36.946 4.553) rotate(90)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_786",
    "data-name": "Caminho 786",
    d: "M407.18,213.21H391.77a3.566,3.566,0,0,0,3.563,3.563h8.275A3.568,3.568,0,0,0,407.18,213.21Z",
    transform: "translate(-379.927 -209.107)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_241",
    "data-name": "Ret\\xE2ngulo 241",
    width: 34.391,
    height: 34.804,
    transform: "translate(36.948 42.034) rotate(90)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_242",
    "data-name": "Ret\\xE2ngulo 242",
    width: 34.391,
    height: 34.804,
    transform: "translate(36.95 79.515) rotate(90)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_243",
    "data-name": "Ret\\xE2ngulo 243",
    width: 34.391,
    height: 34.804,
    transform: "translate(36.943 116.995) rotate(90)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_787",
    "data-name": "Caminho 787",
    d: "M407.18,254.97H391.77a3.566,3.566,0,0,0,3.563,3.563h8.275A3.568,3.568,0,0,0,407.18,254.97Z",
    transform: "translate(-379.927 -213.389)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_788",
    "data-name": "Caminho 788",
    d: "M407.18,296.73H391.77a3.566,3.566,0,0,0,3.563,3.563h8.275A3.556,3.556,0,0,0,407.18,296.73Z",
    transform: "translate(-379.927 -217.67)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_789",
    "data-name": "Caminho 789",
    d: "M407.18,338.49H391.77a3.566,3.566,0,0,0,3.563,3.563h8.275A3.556,3.556,0,0,0,407.18,338.49Z",
    transform: "translate(-379.927 -221.952)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_244",
    "data-name": "Ret\\xE2ngulo 244",
    width: 155.945,
    height: 19.529,
    transform: "translate(58.62 0) rotate(90)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_609",
    "data-name": "Grupo 609",
    transform: "translate(24.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_608",
    "data-name": "Grupo 608"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_245",
    "data-name": "Ret\\xE2ngulo 245",
    width: 11.416,
    height: 31.142,
    transform: "translate(40.817 19.251)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_790",
    "data-name": "Caminho 790",
    d: "M364,202.883h43.545l6.48-50.393H370.48Z",
    transform: "translate(-359.028 -152.49)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_791",
    "data-name": "Caminho 791",
    d: "M358.46,202.883h47.4l6.489-50.393H364.94Z",
    transform: "translate(-358.46 -152.49)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_792",
    "data-name": "Caminho 792",
    d: "M402.921,199.369l5.457-42.459H368.916l-5.466,42.459Z",
    transform: "translate(-358.972 -152.943)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_45",
    "data-name": "Elipse 45",
    cx: 11.533,
    cy: 10.141,
    rx: 11.533,
    ry: 10.141,
    transform: "matrix(0.729, -0.684, 0.684, 0.729, 11.601, 25.701)",
    fill: "#e6e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_613",
    "data-name": "Grupo 613",
    transform: "translate(111.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_612",
    "data-name": "Grupo 612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_611",
    "data-name": "Grupo 611"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_246",
    "data-name": "Ret\\xE2ngulo 246",
    width: 121.787,
    height: 257.386,
    transform: "translate(124.498 257.386) rotate(180)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_247",
    "data-name": "Ret\\xE2ngulo 247",
    width: 121.787,
    height: 257.386,
    transform: "translate(121.787 257.386) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_248",
    "data-name": "Ret\\xE2ngulo 248",
    width: 246.473,
    height: 112.067,
    transform: "translate(116.931 5.457) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_249",
    "data-name": "Ret\\xE2ngulo 249",
    width: 246.473,
    height: 2.046,
    transform: "translate(6.913 5.454) rotate(90)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_250",
    "data-name": "Ret\\xE2ngulo 250",
    width: 117.766,
    height: 7.323,
    transform: "translate(119.786 85.398) rotate(180)",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_617",
    "data-name": "Grupo 617",
    transform: "translate(0 55.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_614",
    "data-name": "Grupo 614",
    transform: "translate(0 85.201)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_251",
    "data-name": "Ret\\xE2ngulo 251",
    width: 16.971,
    height: 110.057,
    transform: "translate(90.22 110.057) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_252",
    "data-name": "Ret\\xE2ngulo 252",
    width: 83.707,
    height: 6.973,
    transform: "translate(86.961 117.03) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_253",
    "data-name": "Ret\\xE2ngulo 253",
    width: 73.252,
    height: 110.057,
    transform: "translate(0 0.002)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_254",
    "data-name": "Ret\\xE2ngulo 254",
    width: 59.906,
    height: 36.096,
    transform: "translate(6.668 13.545)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_255",
    "data-name": "Ret\\xE2ngulo 255",
    width: 59.906,
    height: 36.096,
    transform: "translate(6.668 60.42)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_793",
    "data-name": "Caminho 793",
    d: "M73.884,292.6V279.878a2.032,2.032,0,0,0-2.028-2.028h-.9a2.032,2.032,0,0,0-2.028,2.028V292.6a2.032,2.032,0,0,0,2.028,2.028h.9A2.032,2.032,0,0,0,73.884,292.6Z",
    transform: "translate(-55.073 -254.648)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_794",
    "data-name": "Caminho 794",
    d: "M73.884,344.826V332.108a2.032,2.032,0,0,0-2.028-2.028h-.9a2.032,2.032,0,0,0-2.028,2.028v12.717a2.032,2.032,0,0,0,2.028,2.028h.9A2.038,2.038,0,0,0,73.884,344.826Z",
    transform: "translate(-55.073 -260.003)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_616",
    "data-name": "Grupo 616",
    transform: "translate(23.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_795",
    "data-name": "Caminho 795",
    d: "M131.085,181.444c-1.9.951-7.063-.072-5.34,3.419a29.527,29.527,0,0,0,3.527,5.125c1.921,2.369,1.562,4.936-.709,5.869a2.875,2.875,0,0,0-1.256.871c-1.041,1.5,1.427,3.509,2.63,5.008,1.167,1.445,1.7,2.98.808,4.092-.987,1.23-3.051.781-4.685,1.149-3.931.9.108,6.318-.305,9.109-.287,1.912-1.831,2.441-3.94,2.71-1.714.224-4,.377-4.1,2.136-.081,1.517,1.9,3.249,2.414,4.846A5.035,5.035,0,0,1,119.75,230a4.6,4.6,0,0,1-3.087,2.019c-1.948.413-4.891-.018-5.035,2.181-.063.978.619,1.849.144,2.755a3.155,3.155,0,0,1-2.289,1.346,16.5,16.5,0,0,1-5.618-.1c-2.289-.422-5.663-2.432-4.425-4.38a2.642,2.642,0,0,1,1.768-1.014c.547-.108,2.145.063,2.351-.305s-.35-1.8-.368-2.324a10.768,10.768,0,0,1,.664-4.191,12.862,12.862,0,0,1,2.953-4.676c.538-.547,1.409-.951,1.517-1.75a3.877,3.877,0,0,0-.951-2.459c-.88-1.23-2.235-2.405-2.719-3.724-.772-2.073,1.095-2.728,2.827-3.2,1.562-.422,3.626-.969,3.087-2.872-.386-1.373-2.109-2.495-2.63-3.832-.691-1.795,1-1.867,2.217-2.5,1.58-.835,1.974-2.315,1.4-4.2-.942-3.105-6.632-7.476-3.716-9.5.736-.512,1.427-.682,1.867-1.454.476-.826.547-1.849,1.167-2.594.978-1.185,3.007-1.382,4.066-2.486,2.172-2.253-2.522-6.255,1.759-7.207a5.092,5.092,0,0,0,2.5-1.032c.395-.368.709-2.136,1.149-2.262,1.965-.547,5.51,3.267,6.623,4.442C128.347,176.086,133.364,180.3,131.085,181.444Z",
    transform: "translate(-81.4 -158.409)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_796",
    "data-name": "Caminho 796",
    d: "M95.354,232.681c1.167-2.163,6.264-4.317,2.881-6.821a28.384,28.384,0,0,0-5.852-3.051c-2.962-1.23-4.021-4.092-2.513-6.453a3.557,3.557,0,0,0,.637-1.669c.117-2.181-3.132-2.71-5-3.491-1.8-.754-3.1-1.992-2.9-3.689.215-1.876,2.271-2.692,3.518-4.092,2.989-3.357-3.482-6.4-4.6-9.513-.772-2.136.314-3.635,2.019-5.223,1.4-1.292,3.33-2.872,2.477-4.73-.745-1.606-3.41-2.145-4.73-3.455a6.388,6.388,0,0,1-1.921-4.55,5.906,5.906,0,0,1,1.642-3.985c1.5-1.633,4.326-3.024,3.276-5.367-.467-1.041-1.535-1.508-1.606-2.728a3.994,3.994,0,0,1,1.3-2.8,16.634,16.634,0,0,1,5.008-3.383c2.244-1,6.3-1.023,6.246,1.732a3.384,3.384,0,0,1-1.014,2.136c-.422.458-1.93,1.274-1.912,1.777s1.265,1.624,1.571,2.145a14.365,14.365,0,0,1,1.66,4.712,17.679,17.679,0,0,1-.1,6.623c-.179.9-.736,1.849-.4,2.737a4.165,4.165,0,0,0,2.154,1.93c1.436.718,3.258,1.077,4.4,2.127,1.786,1.642.494,3.473-.781,5.035-1.149,1.409-2.674,3.249-1.194,4.864,1.077,1.167,3.195,1.239,4.371,2.289,1.571,1.409.117,2.531-.61,3.94-.942,1.831-.5,3.6,1.014,5.169,2.495,2.594,9.854,3.545,8.364,7.413a6.586,6.586,0,0,0-.871,2.648c.018,1.14.512,2.235.359,3.383-.233,1.822-1.912,3.285-2.253,5.071-.709,3.662,5.573,4.846,2.306,8.481a6.183,6.183,0,0,0-1.651,2.612c-.153.619.521,2.63.188,3.024-1.436,1.777-6.605.081-8.221-.44C100.64,236.46,93.963,235.257,95.354,232.681Z",
    transform: "translate(-79.37 -157.063)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_615",
    "data-name": "Grupo 615",
    transform: "translate(2.917 70.745)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_797",
    "data-name": "Caminho 797",
    d: "M82.62,235.89s.619,14.458,24.286,14.458,24.286-14.458,24.286-14.458Z",
    transform: "translate(-82.62 -235.89)",
    fill: "#f0f0f0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_",
    transform: "translate(50.357 369.039)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__74_",
    cx: 174.011,
    cy: 10.159,
    rx: 174.011,
    ry: 10.159,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_",
    transform: "translate(235.895 105.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_624",
    "data-name": "Grupo 624"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_798",
    "data-name": "Caminho 798",
    d: "M312.528,406.089l-7.2-.108-1.66-16.711,7.207.108Z",
    transform: "translate(-267.03 -139.824)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_799",
    "data-name": "Caminho 799",
    d: "M353.375,406.134h-7.207L340.55,389.45h7.207Z",
    transform: "translate(-270.811 -139.843)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_800",
    "data-name": "Caminho 800",
    d: "M344.218,407.11H353a.624.624,0,0,1,.61.494l1.427,6.4a1.066,1.066,0,0,1-1.059,1.283c-2.827-.045-4.891-.215-8.445-.215-2.19,0-8.8.224-11.82.224-2.962,0-3.419-2.989-2.181-3.258,5.546-1.212,9.738-2.89,11.515-4.487A1.776,1.776,0,0,1,344.218,407.11Z",
    transform: "translate(-269.821 -141.653)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_801",
    "data-name": "Caminho 801",
    d: "M303.591,406.96l7.862.126a.624.624,0,0,1,.6.5l1.319,6.426a1.052,1.052,0,0,1-1.059,1.265c-2.836-.09-6.937-.323-10.5-.377-4.173-.063-7.772.108-12.663.027-2.953-.045-3.734-3.051-2.486-3.3,5.654-1.14,10.258-1.2,15.176-4.128A3.34,3.34,0,0,1,303.591,406.96Z",
    transform: "translate(-265.227 -141.638)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_802",
    "data-name": "Caminho 802",
    d: "M305.856,168.315a162.721,162.721,0,0,1-7.593,14.79c-1.391,2.4-2.854,4.775-4.425,7.117a78.4,78.4,0,0,1-5.1,6.9l-.718.844-.359.422c-.126.144-.206.251-.458.512a8.68,8.68,0,0,1-3.823,2.495,7.2,7.2,0,0,1-2.827.3,8.1,8.1,0,0,1-2.432-.628,10.36,10.36,0,0,1-2.989-2.055A19.257,19.257,0,0,1,272,194.89a41.086,41.086,0,0,1-2.037-4,78.917,78.917,0,0,1-4.936-16.11l5.16-1.606c1.1,2.351,2.244,4.784,3.446,7.108s2.414,4.631,3.733,6.749a31.992,31.992,0,0,0,2.028,2.98,11.612,11.612,0,0,0,1.983,2.118c.269.206.476.251.368.171a1.13,1.13,0,0,0-.476-.153,2.386,2.386,0,0,0-.835.054c-.538.171-.619.305-.565.188l1.005-1.373a125.436,125.436,0,0,0,7.943-13.184c2.477-4.586,4.882-9.379,7.126-14.019Z",
    transform: "translate(-263.068 -116.709)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_619",
    "data-name": "Grupo 619",
    transform: "translate(20.271 41.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_803",
    "data-name": "Caminho 803",
    d: "M310.945,163.155c1.939,6.605-11.73,24.627-11.73,24.627l-13.785-8.876a88.094,88.094,0,0,1,9.558-16.2C300.624,155.508,308.809,155.9,310.945,163.155Z",
    transform: "translate(-285.43 -157.507)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_804",
    "data-name": "Caminho 804",
    d: "M310.945,163.155c1.939,6.605-11.73,24.627-11.73,24.627l-13.785-8.876a88.094,88.094,0,0,1,9.558-16.2C300.624,155.508,308.809,155.9,310.945,163.155Z",
    transform: "translate(-285.43 -157.507)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_805",
    "data-name": "Caminho 805",
    d: "M303.441,172.424c-2.836,1.212-7.009,8.041-9.181,13.1l5.852,3.76a110.2,110.2,0,0,0,8.8-13.785C307.058,173.474,304.94,171.787,303.441,172.424Z",
    transform: "translate(-266.065 -117.578)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_806",
    "data-name": "Caminho 806",
    d: "M269.823,176.155l1.768-8.122-8.2-.063s-2.19,6.1,2.217,8.948Z",
    transform: "translate(-262.844 -117.135)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_807",
    "data-name": "Caminho 807",
    d: "M270.721,159.55l-6.569,2.369-.691,5.187,8.194.063Z",
    transform: "translate(-262.907 -116.272)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_808",
    "data-name": "Caminho 808",
    d: "M303.68,389.27l.853,8.616,7.2.117-.844-8.616Z",
    transform: "translate(-267.031 -139.824)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_809",
    "data-name": "Caminho 809",
    d: "M347.757,389.46H340.55l2.9,8.6h7.207Z",
    transform: "translate(-270.811 -139.844)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_620",
    "data-name": "Grupo 620",
    transform: "translate(31.163 40.356)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_810",
    "data-name": "Caminho 810",
    d: "M344.3,160.1c-7.763,27.364-6.193,56.406-6.893,62.285-5.636-.413-26.861-1.992-38.43-2.854-5.044-41.006,5.044-62.069,5.044-62.069s2.468-.476,5.834-.826c1.05-.108,2.19-.206,3.375-.269.655-.036,1.319-.063,1.992-.072a141.869,141.869,0,0,1,16.334,1.221c1.023.126,2.064.278,3.078.449.933.162,1.858.332,2.719.5C341.277,159.252,344.3,160.1,344.3,160.1Z",
    transform: "translate(-297.566 -156.294)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_811",
    "data-name": "Caminho 811",
    d: "M344.3,160.1c-7.763,27.364-6.193,56.406-6.893,62.285-5.636-.413-26.861-1.992-38.43-2.854-5.044-41.006,5.044-62.069,5.044-62.069s2.468-.476,5.834-.826c1.05-.108,2.19-.206,3.375-.269.655-.036,1.319-.063,1.992-.072a141.869,141.869,0,0,1,16.334,1.221c1.023.126,2.064.278,3.078.449.933.162,1.858.332,2.719.5C341.277,159.252,344.3,160.1,344.3,160.1Z",
    transform: "translate(-297.566 -156.294)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_812",
    "data-name": "Caminho 812",
    d: "M340.473,173.62c-.691,2.648.1,14.728,2.863,17.707.377-3.868.88-7.907,1.544-12.035Z",
    transform: "translate(-270.779 -117.714)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_813",
    "data-name": "Caminho 813",
    d: "M333.147,137.03c-1.418,5.178-3.168,14.728.251,18.515-3.069,2.63-7.045,5.627-13.3,5.385s-4.846-4.46-3.033-6.6c5.968-.96,6.139-5.322,5.421-9.486Z",
    transform: "translate(-268.245 -113.963)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_814",
    "data-name": "Caminho 814",
    d: "M333.317,156s-2.585,4.263-12.977,6.857c1.723,1.589,2.558,5.358,2.558,5.358s13.561-3.276,13.148-10.868A9.122,9.122,0,0,0,333.317,156Z",
    transform: "translate(-268.739 -115.908)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_815",
    "data-name": "Caminho 815",
    d: "M315.974,167.244s1.364-3.285,3.7-4.407c-1.086-1.131-2.719-4.514-1.741-7.009a8.5,8.5,0,0,0-2.414.153S311.415,161.159,315.974,167.244Z",
    transform: "translate(-268.07 -115.889)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_816",
    "data-name": "Caminho 816",
    d: "M319.678,168.5c-.126.709-.53,1.221-.915,1.158s-.583-.691-.467-1.4.53-1.221.915-1.158S319.8,167.79,319.678,168.5Z",
    transform: "translate(-268.526 -117.045)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_817",
    "data-name": "Caminho 817",
    d: "M319,173.005c-.063.709-.422,1.265-.808,1.23s-.646-.637-.583-1.355.422-1.265.808-1.23S319.063,172.3,319,173.005Z",
    transform: "translate(-268.458 -117.512)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_818",
    "data-name": "Caminho 818",
    d: "M329.6,140.59l-6.309,4.622a17.465,17.465,0,0,1,.287,2.935c2.262-.162,5.519-2.387,5.932-4.712A8.235,8.235,0,0,0,329.6,140.59Z",
    transform: "translate(-269.041 -114.328)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_819",
    "data-name": "Caminho 819",
    d: "M318.507,115.21c-5.6-.117-6.722,13.408-3.1,15.769S328.99,115.434,318.507,115.21Z",
    transform: "translate(-268.019 -111.726)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_820",
    "data-name": "Caminho 820",
    d: "M334.129,126.991c-.969,7.081-1.176,11.281-5.035,14.665-5.816,5.089-14.36,1.176-15.526-6.049-1.05-6.507.709-17,7.88-19.314A9.749,9.749,0,0,1,334.129,126.991Z",
    transform: "translate(-268.016 -111.786)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_821",
    "data-name": "Caminho 821",
    d: "M334.916,134.09c-3.608,1.894-7.736-17.707,1.813-16.684C348.674,118.68,342.122,130.311,334.916,134.09Z",
    transform: "translate(-269.816 -111.947)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_822",
    "data-name": "Caminho 822",
    d: "M317.57,116.742c0,4.389,14.243,8.75,19.125,7.252s6.1-5.34,3.491-8.077C335.753,111.276,317.57,108.144,317.57,116.742Z",
    transform: "translate(-268.455 -111.328)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_823",
    "data-name": "Caminho 823",
    d: "M318.1,118.02a8.39,8.39,0,0,0,2.055,3.877c-1.274-.072-2.54-1.876-2.944-2.935C316.807,117.921,318.1,118.02,318.1,118.02Z",
    transform: "translate(-268.41 -112.014)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_824",
    "data-name": "Caminho 824",
    d: "M338.627,136.709a6.8,6.8,0,0,1-4.443,2.674c-2.36.341-3.231-1.849-2.315-3.913.826-1.858,3.042-4.272,5.286-3.662A3.055,3.055,0,0,1,338.627,136.709Z",
    transform: "translate(-269.884 -113.418)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_825",
    "data-name": "Caminho 825",
    d: "M300.2,379.52l12.2.188s-4.066-48.185-2.971-70.6a234.174,234.174,0,0,1,3.509-26.583c2.28-12.879,3.374-18.021,6.309-34.3,2.1-11.613,3.967-19.574,3.967-19.574l-25.264-1.876s-10.716,58.066-10.465,80.055C287.731,329.674,300.2,379.52,300.2,379.52Z",
    transform: "translate(-265.369 -123.164)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_826",
    "data-name": "Caminho 826",
    d: "M316.939,246c-4.541,11.308-4.631,37.8-2.54,45.26.359-2.208.745-4.469,1.149-6.767,2.28-12.888,3.375-18.021,6.318-34.3.054-.323.117-.637.171-.951A17.5,17.5,0,0,0,316.939,246Z",
    transform: "translate(-267.995 -125.135)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_827",
    "data-name": "Caminho 827",
    d: "M314.33,227.89s2.235,60.75,3.922,81.787c1.858,23.038,19.125,70.146,19.125,70.146H350.57s-8.8-43.115-11.506-65.489c-3.078-25.488.054-84.6.054-84.6Z",
    transform: "translate(-268.122 -123.279)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_828",
    "data-name": "Caminho 828",
    d: "M338.041,396.935h15.535V392.3l-17.366-.305Z",
    transform: "translate(-270.366 -140.103)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_829",
    "data-name": "Caminho 829",
    d: "M299.752,396.692l14.53.224.072-4.694-16.244-.5Z",
    transform: "translate(-266.46 -140.076)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_830",
    "data-name": "Caminho 830",
    d: "M324.163,129.464c-.045.583-.386,1.023-.763,1s-.655-.521-.61-1.1.386-1.023.763-1S324.207,128.889,324.163,129.464Z",
    transform: "translate(-268.989 -113.074)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_831",
    "data-name": "Caminho 831",
    d: "M316.863,128.924c-.045.583-.386,1.023-.763,1s-.655-.521-.61-1.1.386-1.023.763-1S316.907,128.34,316.863,128.924Z",
    transform: "translate(-268.241 -113.018)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_832",
    "data-name": "Caminho 832",
    d: "M318.961,129.54a20.738,20.738,0,0,1-3.141,4.748,3.353,3.353,0,0,0,2.728.727Z",
    transform: "translate(-268.275 -113.195)",
    fill: "#ed893e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_833",
    "data-name": "Caminho 833",
    d: "M321.354,137.35a4.786,4.786,0,0,0,3.41-1.651.173.173,0,0,0-.278-.206,4.6,4.6,0,0,1-3.877,1.517.171.171,0,0,0-.018.341A5.406,5.406,0,0,0,321.354,137.35Z",
    transform: "translate(-268.748 -113.798)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_834",
    "data-name": "Caminho 834",
    d: "M326.436,127.156a.269.269,0,0,0,.162-.054.336.336,0,0,0,.1-.476,3.367,3.367,0,0,0-2.666-1.606.341.341,0,1,0,0,.682h0a2.71,2.71,0,0,1,2.1,1.3A.318.318,0,0,0,326.436,127.156Z",
    transform: "translate(-269.082 -112.732)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_835",
    "data-name": "Caminho 835",
    d: "M314.03,126.054a.35.35,0,0,0,.278-.171,2.682,2.682,0,0,1,2.037-1.391.342.342,0,0,0-.036-.682,3.375,3.375,0,0,0-2.585,1.732.341.341,0,0,0,.126.467A.353.353,0,0,0,314.03,126.054Z",
    transform: "translate(-268.056 -112.607)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_621",
    "data-name": "Grupo 621",
    transform: "translate(33.289 263.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_836",
    "data-name": "Caminho 836",
    d: "M342.88,408.312a8.233,8.233,0,0,0,1.885-.26.175.175,0,0,0,.126-.135.163.163,0,0,0-.081-.171c-.26-.162-2.585-1.589-3.383-1.185a.54.54,0,0,0-.3.485,1.022,1.022,0,0,0,.35.9A2.281,2.281,0,0,0,342.88,408.312Zm1.391-.5a3.541,3.541,0,0,1-2.558-.126.7.7,0,0,1-.233-.619c.009-.135.063-.18.108-.2C342,406.643,343.328,407.262,344.271,407.809Z",
    transform: "translate(-304.158 -404.625)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_837",
    "data-name": "Caminho 837",
    d: "M344.9,407.858a.152.152,0,0,0,.09-.027.176.176,0,0,0,.081-.153c-.009-.09-.18-2.163-1.014-2.854a.915.915,0,0,0-.727-.215h0a.56.56,0,0,0-.538.449c-.153.8,1.292,2.378,2.037,2.782A.169.169,0,0,0,344.9,407.858Zm-1.454-2.917a.578.578,0,0,1,.395.153,4.145,4.145,0,0,1,.853,2.253c-.745-.565-1.66-1.759-1.571-2.226.009-.045.027-.144.251-.17h0A.174.174,0,0,1,343.444,404.941Z",
    transform: "translate(-304.328 -404.432)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_838",
    "data-name": "Caminho 838",
    d: "M304.283,407.875a.164.164,0,0,0,.117-.135.182.182,0,0,0-.09-.18c-.323-.171-3.195-1.687-4.083-1.212a.542.542,0,0,0-.287.449h0a.969.969,0,0,0,.305.835c.781.709,2.845.458,4.012.251C304.274,407.875,304.274,407.875,304.283,407.875Zm-3.823-1.256c.547-.18,2.109.44,3.24,1.005-1.6.242-2.782.153-3.213-.251a.636.636,0,0,1-.2-.547.211.211,0,0,1,.108-.18A.438.438,0,0,1,300.46,406.619Z",
    transform: "translate(-299.935 -404.602)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_839",
    "data-name": "Caminho 839",
    d: "M304.488,407.686c.018-.009.027-.009.045-.018a.151.151,0,0,0,.072-.153c-.009-.081-.171-2.028-1.077-2.791a1.227,1.227,0,0,0-.942-.305h0c-.467.036-.61.278-.646.467-.144.817,1.553,2.4,2.414,2.8A.336.336,0,0,0,304.488,407.686Zm-2.046-2.908a.7.7,0,0,1,.171-.036h0a.935.935,0,0,1,.691.224,4,4,0,0,1,.915,2.235c-.88-.547-2.028-1.786-1.948-2.28A.25.25,0,0,1,302.442,404.778Zm.162-.2Z",
    transform: "translate(-300.14 -404.412)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_623",
    "data-name": "Grupo 623",
    transform: "translate(67.065 43.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_840",
    "data-name": "Caminho 840",
    d: "M350.576,165.54c2.513,5.044,4.766,10.088,6.839,15.293,1.05,2.594,2.019,5.214,2.971,7.871.467,1.328.915,2.665,1.346,4.021l.323,1.014.35,1.167c.251.8.4,1.6.583,2.4a44.008,44.008,0,0,1-.826,18.147,67.793,67.793,0,0,1-2.531,8.3c-.512,1.346-1.059,2.665-1.642,3.976-.583,1.328-1.176,2.576-1.9,3.922l-4.963-2.154c.691-2.45,1.391-5.089,1.885-7.664.538-2.585.951-5.178,1.238-7.745a52.855,52.855,0,0,0,.305-7.584,29.914,29.914,0,0,0-.987-7.036c-.171-.53-.305-1.077-.512-1.58-.108-.269-.171-.485-.3-.79l-.386-.924c-.5-1.23-1.05-2.459-1.571-3.689-1.05-2.468-2.181-4.918-3.285-7.386L340.74,170.35Z",
    transform: "translate(-337.895 -160.421)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_622",
    "data-name": "Grupo 622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_841",
    "data-name": "Caminho 841",
    d: "M348.4,160.468c6.57,2.055,13.04,24.348,13.04,24.348l-15.2,6.659s-4.918-10.77-7.745-19.206C335.4,163.061,340.433,157.973,348.4,160.468Z",
    transform: "translate(-337.571 -159.836)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_842",
    "data-name": "Caminho 842",
    d: "M348.4,160.468c6.57,2.055,13.04,24.348,13.04,24.348l-15.2,6.659s-4.918-10.77-7.745-19.206C335.4,163.061,340.433,157.973,348.4,160.468Z",
    transform: "translate(-337.571 -159.836)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_843",
    "data-name": "Caminho 843",
    d: "M352.365,235.39l-3.545,6.4,8.355,2.172s2.531-6.21-.458-8.176Z",
    transform: "translate(-338.724 -167.582)",
    fill: "#ffb573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_844",
    "data-name": "Caminho 844",
    d: "M348.13,249.781l7.673.637,1.3-5.726-8.355-2.172Z",
    transform: "translate(-338.653 -168.313)",
    fill: "#ffb573"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Shield",
    transform: "translate(73.44 72.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_629",
    "data-name": "Grupo 629",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_845",
    "data-name": "Caminho 845",
    d: "M275.057,267.578H85.17L98.56,77.7H288.448Z",
    transform: "translate(-82.172 -74.909)",
    fill: "#407bff",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_846",
    "data-name": "Caminho 846",
    d: "M129.72,267.578H102.41L170.447,77.7h27.31Z",
    transform: "translate(-83.94 -74.909)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_847",
    "data-name": "Caminho 847",
    d: "M199.868,267.578H139.63L207.658,77.7H267.9Z",
    transform: "translate(-87.756 -74.909)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_625",
    "data-name": "Grupo 625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_848",
    "data-name": "Caminho 848",
    d: "M100.015,109.807l-5.555-.395L96.91,74.59h34.831v5.582H102.106Z",
    transform: "translate(-83.125 -74.59)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_849",
    "data-name": "Caminho 849",
    d: "M117.056,288.358H81.83l2.486-35.208,5.564.395-2.064,29.231h29.24Z",
    transform: "translate(-81.83 -92.897)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_850",
    "data-name": "Caminho 850",
    d: "M308.49,109.807l-5.555-.395,2.055-29.24H275.75V74.59h35.226Z",
    transform: "translate(-101.712 -74.59)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_851",
    "data-name": "Caminho 851",
    d: "M295.661,288.358H260.83v-5.582h29.635l2.091-29.626,5.564.395Z",
    transform: "translate(-100.182 -92.897)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_628",
    "data-name": "Grupo 628",
    transform: "translate(49.226 35.968)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_852",
    "data-name": "Caminho 852",
    d: "M188.347,243.367a1.126,1.126,0,0,1-.476-.117c-.054-.027-1.373-.754-3.59-2.109-.933-.565-2.028-1.256-3.258-2.046-3.9-2.54-7.664-5.205-11.191-7.952-.853-.664-1.705-1.346-2.585-2.055-3.249-2.657-6.246-5.331-8.912-7.952-.682-.673-1.364-1.355-2.037-2.055a91.651,91.651,0,0,1-6.884-7.979c-.521-.673-1.023-1.364-1.517-2.064a61.226,61.226,0,0,1-4.873-8.023c-.341-.673-.682-1.373-1-2.082a43.317,43.317,0,0,1-2.755-8.068c-.153-.637-.3-1.319-.431-2.091-.09-.5-.171-1.032-.242-1.562-.269-2.055-.512-4.146-.736-6.408-.072-.673-.135-1.346-.2-2.028-.233-2.657-.422-5.322-.565-7.943l-.018-.269c-.036-.6-.072-1.185-.1-1.777-.126-2.585-.215-5.25-.26-7.925l-.027-2.037c-.027-2.827-.027-5.493.018-7.925.009-.682.027-1.364.036-2.037.063-2.926.162-5.591.278-7.925l.009-.153c.027-.646.063-1.274.1-1.894.162-2.89.35-5.636.538-7.925.063-.79.117-1.454.179-2.046.206-2.262.359-3.518.359-3.518a.977.977,0,0,1,.906-.862c.162-.009,16.72-1.283,34.364-4.389,3.572-.628,7.054-1.31,10.33-2.019,4.837-1.05,9.271-2.2,13.166-3.419a.983.983,0,0,1,.6,0c3.725,1.212,7.987,2.36,12.681,3.419,3.177.718,6.561,1.391,10.043,2.019,17.2,3.105,33.574,4.371,33.736,4.389a.993.993,0,0,1,.915,1.005s-.027,1.265-.135,3.527q-.04.915-.108,2.046c-.126,2.307-.332,5.044-.574,7.925-.045.574-.1,1.158-.153,1.75l-.027.3c-.215,2.351-.494,5.017-.835,7.925-.081.691-.162,1.364-.251,2.037-.305,2.441-.673,5.107-1.1,7.916L251.458,161c-.431,2.7-.9,5.367-1.382,7.934-.108.574-.224,1.158-.341,1.741l-.063.305c-.512,2.6-1.077,5.268-1.687,7.925-.162.682-.323,1.364-.494,2.046-.538,2.253-1.077,4.344-1.633,6.4-.144.521-.3,1.05-.467,1.562-.242.763-.476,1.454-.727,2.091a50.117,50.117,0,0,1-3.877,8.032c-.4.691-.835,1.391-1.283,2.073a75.609,75.609,0,0,1-5.986,8c-.592.691-1.185,1.382-1.8,2.055a111.7,111.7,0,0,1-8,7.961c-.772.7-1.544,1.382-2.315,2.055-3.033,2.621-6.408,5.286-10.025,7.934-.969.709-1.93,1.391-2.872,2.046-3.913,2.737-8.041,5.412-12.3,7.934-1.346.79-2.54,1.472-3.554,2.046-2.405,1.355-3.823,2.073-3.877,2.109A.733.733,0,0,1,188.347,243.367ZM140.09,126.454c-.063.592-.153,1.49-.269,2.665-.054.592-.108,1.239-.171,1.956-.2,2.333-.386,5.053-.547,7.934-.036.61-.063,1.23-.1,1.876l-.009.153c-.117,2.315-.215,4.963-.278,7.871-.018.664-.036,1.337-.036,2.019-.045,2.414-.045,5.062-.018,7.871l.027,2.028c.054,2.648.144,5.3.26,7.862.027.583.063,1.167.1,1.759l.018.269c.144,2.6.332,5.241.565,7.862.063.673.126,1.346.2,2.019.224,2.244.458,4.317.727,6.345.063.494.135.987.224,1.472.126.736.26,1.382.413,1.983a41.766,41.766,0,0,0,2.639,7.718c.305.682.619,1.346.951,1.992a59.351,59.351,0,0,0,4.721,7.772c.476.673.969,1.346,1.472,2a90.979,90.979,0,0,0,6.74,7.817c.664.691,1.328,1.355,2,2.019,2.621,2.576,5.573,5.205,8.777,7.826.862.691,1.705,1.364,2.549,2.028,3.482,2.7,7.2,5.34,11.048,7.844,1.2.772,2.289,1.454,3.222,2.019,1.427.88,2.495,1.49,3.051,1.813.6-.314,1.759-.933,3.339-1.822,1.005-.565,2.19-1.247,3.518-2.019,4.2-2.5,8.293-5.143,12.161-7.853.933-.655,1.876-1.328,2.836-2.028,3.572-2.621,6.9-5.25,9.89-7.835q1.144-1,2.289-2.019a109.612,109.612,0,0,0,7.853-7.826c.61-.664,1.194-1.337,1.768-2.01a72.976,72.976,0,0,0,5.834-7.79c.431-.664.853-1.337,1.239-2a49.092,49.092,0,0,0,3.733-7.736c.242-.61.467-1.265.691-1.992.162-.494.305-.987.44-1.49.556-2.028,1.086-4.1,1.624-6.345.171-.682.323-1.355.485-2.028.6-2.63,1.167-5.277,1.669-7.862l.063-.314c.117-.574.224-1.149.332-1.723.485-2.549.942-5.2,1.373-7.871l.305-2.028c.422-2.791.79-5.439,1.095-7.871.09-.673.162-1.346.242-2,.341-2.908.628-5.555.835-7.889l.027-.3c.054-.592.108-1.167.153-1.732h0c.242-2.854.44-5.573.574-7.862q.067-1.117.108-2.019c.054-1.095.09-1.956.108-2.549-3.733-.314-18.057-1.642-33-4.335-3.518-.637-6.92-1.319-10.123-2.037-4.622-1.041-8.849-2.172-12.556-3.366-3.886,1.2-8.266,2.333-13.031,3.374-3.312.718-6.812,1.409-10.411,2.037C158.327,124.838,143.653,126.157,140.09,126.454Z",
    transform: "translate(-136.68 -114.667)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_626",
    "data-name": "Grupo 626",
    transform: "translate(40.948 26.466)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_46",
    "data-name": "Elipse 46",
    cx: 12.197,
    cy: 11.371,
    rx: 12.197,
    ry: 11.371,
    transform: "translate(0 16.941) rotate(-43.991)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_853",
    "data-name": "Caminho 853",
    d: "M202.194,167.29h-5.753l-8.131,37.927h16.666Z",
    transform: "translate(-182.921 -146.529)",
    fill: "#407bff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_627",
    "data-name": "Grupo 627",
    transform: "translate(1.006 4.445)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_854",
    "data-name": "Caminho 854",
    d: "M224.36,121.648H177.88c3.446-.6,6.937-1.283,10.375-2.028h26.018C217.611,120.365,221,121.038,224.36,121.648Z",
    transform: "translate(-141.909 -119.62)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_855",
    "data-name": "Caminho 855",
    d: "M253.956,132.708H138.9c.063-.745.117-1.427.179-2.028H254.073C254.037,131.281,254,131.954,253.956,132.708Z",
    transform: "translate(-137.913 -120.754)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_856",
    "data-name": "Caminho 856",
    d: "M253.308,141.73c-.054.664-.117,1.337-.18,2.037H138.18c.036-.7.063-1.382.108-2.037Z",
    transform: "translate(-137.839 -121.887)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_857",
    "data-name": "Caminho 857",
    d: "M252.257,152.8c-.081.673-.162,1.346-.251,2.028H137.82c.009-.682.027-1.364.036-2.028Z",
    transform: "translate(-137.802 -123.022)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_858",
    "data-name": "Caminho 858",
    d: "M250.908,163.87c-.108.673-.206,1.346-.314,2.028H137.827c-.009-.682-.018-1.355-.027-2.028Z",
    transform: "translate(-137.8 -124.157)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_859",
    "data-name": "Caminho 859",
    d: "M249.255,174.93c-.126.673-.26,1.355-.395,2.037H138.238c-.036-.682-.081-1.364-.108-2.037Z",
    transform: "translate(-137.834 -125.291)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_860",
    "data-name": "Caminho 860",
    d: "M247.25,186c-.162.673-.323,1.355-.485,2.028H139.077c-.072-.673-.135-1.355-.2-2.028Z",
    transform: "translate(-137.911 -126.426)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_861",
    "data-name": "Caminho 861",
    d: "M244.816,197.06c-.215.682-.449,1.364-.709,2.037H140.6c-.171-.673-.305-1.355-.422-2.037Z",
    transform: "translate(-138.044 -127.56)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_862",
    "data-name": "Caminho 862",
    d: "M240.659,208.12c-.395.682-.826,1.373-1.256,2.037H144.629c-.341-.673-.673-1.355-.969-2.037Z",
    transform: "translate(-138.401 -128.694)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_863",
    "data-name": "Caminho 863",
    d: "M234.146,219.19c-.583.682-1.176,1.364-1.786,2.028H151.579c-.521-.673-1.014-1.346-1.5-2.028Z",
    transform: "translate(-139.059 -129.829)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_864",
    "data-name": "Caminho 864",
    d: "M225.384,230.25c-.763.691-1.535,1.373-2.307,2.037H161.349c-.682-.673-1.346-1.346-2.019-2.037Z",
    transform: "translate(-140.007 -130.963)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_865",
    "data-name": "Caminho 865",
    d: "M214.366,241.31c-.969.7-1.912,1.382-2.854,2.037H174.007c-.844-.664-1.7-1.337-2.567-2.037Z",
    transform: "translate(-141.249 -132.097)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_866",
    "data-name": "Caminho 866",
    d: "M200.852,252.38c-1.328.781-2.522,1.463-3.527,2.028h-7.4c-.933-.565-2.019-1.247-3.24-2.028Z",
    transform: "translate(-142.813 -133.232)",
    fill: "#407bff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyYourIdentity);
export default __webpack_public_path__ + "static/media/verify-your-identity.8ffd183fbdd9c66d6f3ef9a669b40fc4.svg";
export { ForwardRef as ReactComponent };